/* Add to cart */

/* ==== Console shim ==== */
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

/* ==== Checkout URL unificado (usado en todo el archivo) ==== */
var LELE_CHECKOUT_URL = null;

var GLOBAL = {
  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');

      // Bind add-to-cart (solo botones de "Agregar al carrito")
      if($(window).innerWidth() > 767 ){
        
          $('.add-to-cart').off('click.cs').on('click.cs', addToCart);
        
      } else {
        $('.add-to-cart').off('click.cs').on('click.cs', directAddToCart);
      }

      $('.cart-form .clearAllCart').off('click.cs').on('click.cs', clearAllCart);

      /* ==== Guard global: reescribe cualquier /products/null a checkout ==== */
      try {
        // Si ya estamos en /products/null por navegación programática
        var p = location.pathname.replace(/\/+$/,'').toLowerCase();
        if (p === '/products/null') { location.replace(LELE_CHECKOUT_URL); }
      } catch(e){}

      function isNullHref(href){
        if (!href) return false;
        href = String(href);
        return /(^|:\/\/[^\/]+)\/products\/null(?:[?#].*)?$/i.test(href) || /\/products\/null(?:[?#].*)?$/i.test(href);
      }
      function rewriteNullLinks(root){
        (root.querySelectorAll ? root.querySelectorAll('a[href]') : []).forEach(function(a){
          var h = a.getAttribute('href');
          if (isNullHref(h)) a.setAttribute('href', LELE_CHECKOUT_URL);
        });
      }
      rewriteNullLinks(document);

      // Capturamos clics antes que otros scripts
      document.addEventListener('click', function(e){
        var a = e.target && e.target.closest && e.target.closest('a[href]');
        if (!a) return;
        var href = a.getAttribute('href') || '';
        if (isNullHref(href)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          try { a.setAttribute('href', LELE_CHECKOUT_URL); } catch(_){}
          location.assign(LELE_CHECKOUT_URL);
        }
      }, true);

      // Observa mutaciones que inyecten /products/null (apps/payment button, etc.)
      if ('MutationObserver' in window){
        new MutationObserver(function(muts){
          muts.forEach(function(m){
            if (m.type === 'attributes' && m.target && m.target.tagName === 'A' && m.attributeName === 'href') {
              var href = m.target.getAttribute('href');
              if (isNullHref(href)) m.target.setAttribute('href', LELE_CHECKOUT_URL);
            }
            (m.addedNodes || []).forEach(function(n){
              if (n.nodeType !== 1) return;
              if (n.tagName === 'A') {
                var h = n.getAttribute('href');
                if (isNullHref(h)) n.setAttribute('href', LELE_CHECKOUT_URL);
              }
              rewriteNullLinks(n);
            });
          });
        }).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['href']});
      }
    }
  },
  templateIndex : { init: function(){} },
  templateProduct : { init: function(){} },
  templateCart : { init: function(){} }
};

var checkCountDown = 0;
// guardamos la última cantidad añadida para el modal
var __lastAddedQty = 1;

var UTIL = {
  fire : function(func,funcname, args){
    var namespace = GLOBAL;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },
  loadEvents : function(){
    var bodyId = document.body.id;
    // common siempre primero
    UTIL.fire('common');
    // luego clases del body
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }
};
$(document).ready(UTIL.loadEvents);

/* Fly image to Cart */
function flyToCart(imgobj, cart, time){
  if(imgobj){
    var imgsrc = imgobj.attr('src');
    imgobj.animate_from_to(cart, {
      pixels_per_second: time,
      initial_css: { 'image': imgsrc },
      callback: function(){}
    });
  }
}

/* Popup notify add-to-cart */
function notifyProduct($info){
  if ($.jGrowl) {
    $.jGrowl($info,{ position:'center', life: 500000 });
  }
}

/* Enviar el formulario contenedor (no el botón) */
function directAddToCart(e){
  var $form = $(this).closest('form');
  if ($form.length) {
    // Permitimos submit nativo; si el layout intercepta, hará AJAX
    return $form.trigger('submit');
  }
}

/* Ajaxy add-to-cart */
function addToCart(e){
  checkCountDown = 0;

  // Solo mostrar el modal si existe en el DOM
  if ($('#ajax-cart-modal').length) {
    $('#ajax-cart-modal').show();
  }

  if (typeof e !== 'undefined') e.preventDefault();
  var $this = $(this);
  var form = $this.closest('form');
  if (!form || !form.length) return;

  // obtener cantidad real del form
  var q = parseInt(form.find('[name="quantity"]').val(), 10);
  __lastAddedQty = isNaN(q) || q < 1 ? 1 : q;

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });

  // Hide Modal (si hay alguno abierto del tema)
  if ($('.modal').modal) $('.modal').modal('hide');
}

function clearAllCart(){
  if (confirm("Are you sure you want to clear all items in cart?") == true) {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){ location.reload(); },
      dataType: 'json'
    });
  }
}

function addToCartSuccess (jqXHR){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: true,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });

  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '.cart-info .cart-content');
  });

  var ai_image  = jqXHR['image'] ? '<img src="'+ Shopify.resizeImage(jqXHR['image'], 'medium') +'" alt="'+ (jqXHR['title']||'') +'"/>' : '';
  var ai_name   = jqXHR['product_title'] || jqXHR['title'] || '';
  var ai_price  = '<span class="money">'+Shopify.formatMoney(jqXHR['price'], cart_money_format)+'</span>';
  var ai_variant= (jqXHR['variant_title'] != null && jqXHR['variant_title'] !== '') ? ('Variant: '+jqXHR['variant_title']) : '';
  var ai_qty    = 'Qty: ' + __lastAddedQty;

  var ai_numpro = "";
  var qtyNow = parseInt($(".navUser-item--cart span.cart-quantity").html() || '0', 10);
  if (qtyNow == 1) ai_numpro = "Translation missing: es.products.ajax_cart.modal_have_1";
  else ai_numpro = "Translation missing: es.products.ajax_cart.modal_have_more_text1"+ qtyNow +"Translation missing: es.products.ajax_cart.modal_have_more_text2";

  var $info = '<span class="cirle"><i class="fa fa-check"></i></span>Producto agregado a<a href="'+ LELE_CHECKOUT_URL +'" class="your_cart"> tu carrito</a>';

  //load data to Ajax Cart Modal (solo si existe)
  if ($('#ajax-cart-modal').length) {
    $(".ajax-cart-note").removeClass("error").html($info);
    $('.ajax-cart-image').html(ai_image);
    $('.ajax-cart-product-title').html(ai_name);
    $('.ajax-cart-price').html(ai_price);
    $('.ajax-cart-variant').html(ai_variant);
    $('.ajax-cart-qty').html(ai_qty);
    $('.ajax-cart-number-product').html(ai_numpro);
    $('.ajax-cart-loading').hide();
    $('.ajax-cart-box').show().addClass("fadeIn animated");
    countDown(10);
  }
}

function addToCartFail(jqXHR){
  var response = {};
  try { response = $.parseJSON(jqXHR.responseText); } catch(e){ response = { description: 'Unknown error' }; }

  var $info = '<span class="cirle"><i class="fa fa-times"></i></span><div class="error">Translation missing: es.products.ajax_cart.note_text_3<br/>Translation missing: es.products.ajax_cart.error'+ (response.description||'') +'</div>';

  var ai_numpro = "";
  var qtyNow = parseInt($(".navUser-item--cart span.cart-quantity").html() || '0', 10);
  if (qtyNow == 1) ai_numpro = "Translation missing: es.products.ajax_cart.modal_have_1";
  else ai_numpro = "Translation missing: es.products.ajax_cart.modal_have_more_text1"+ qtyNow +"Translation missing: es.products.ajax_cart.modal_have_more_text2";

  // Solo si existe modal
  if ($('#ajax-cart-modal').length) {
    $(".ajax-cart-note").addClass("error").html($info);
    $('.ajax-cart-image').html("");
    $('.ajax-cart-product-title').html("");
    $('.ajax-cart-price').html("");
    $('.ajax-cart-variant').html("");
    $('.ajax-cart-qty').html("");
    $('.ajax-cart-number-product').html(ai_numpro);
    $('.ajax-cart-loading').hide();
    $('.ajax-cart-box').show().addClass("fadeIn animated");
    countDown(10);
  }
}

function searchPlaceholder(){
  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
        input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
        input.addClass('placeholder');
        input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
        var input = $(this);
        if (input.val() == input.attr('placeholder')) {
          input.val('');
        }
      });
    });
  }
}

function ajaxCartHide(){
  if (!$('#ajax-cart-modal').length) return;
  $("#ajax-cart-modal").addClass("zoomOut animated").fadeOut();
  $("#ajax-cart-modal").removeClass("zoomOut animated");
  checkCountDown = 1;
}

/* Cart Get/Update Data */
Shopify.updateCartInfo = function(cart, cart_summary_id, cart_count_id) {
  if ((typeof cart_summary_id) === 'string') {
    var cart_summary = jQuery(cart_summary_id);
    if (cart_summary.length) {
      // limpiar
      cart_summary.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          if (value.length) {
            jQuery('<div class="text-items"><p><span class="bold">'+cart.item_count +'</span> Tienes más productos en tu carrito</p></div>').appendTo(cart_summary);
            jQuery('<div class="items control-container"></div>').appendTo(cart_summary);
            var table = jQuery(cart_summary_id + ' div.items');

            jQuery.each(value, function(i, item) {
              jQuery(
                '<div class="row">' +
                  '<a class="cart-close" title="Remove" href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="fa fa-times"></i></a>' +
                  '<div class="cart-left"><a class="cart-image" href="' + item.url + '"><img src="' + Shopify.resizeImage(item.image, 'compact') + '" alt="" title=""/></a></div>' +
                  '<div class="cart-right">' +
                    '<div class="cart-title"><a href="' + item.url + '">' + item.title + '</a></div>' +
                    '<div class="cart-price"><span class="money">' + Shopify.formatMoney(item.price, cart_money_format) + '</span><span class="x"> x' + item.quantity + '</span></div>' +
                  '</div>' +
                '</div>'
              ).appendTo(table);
            });

            jQuery('<div class="subtotal"><span>Subtotal:</span><span class="cart-total-right money">' + Shopify.formatMoney(cart.total_price, cart_money_format) + '</span></div>').appendTo(cart_summary);

            /* ==== Acciones mini-cart: SOLO "Comprar" → checkout ==== */
            var actionsHtml =
              '<div class="previewCartAction">' +
                '<div class="previewCartAction-checkout">' +
                  '<a href="'+ LELE_CHECKOUT_URL +'" class="button button--small button--primary" data-lele="go-checkout">' +
                    '<svg class="lnr lnr-cart"><use xlink:href="#lnr-cart"></use></svg>Continuar' +
                  '</a>' +
                '</div>' +
              '</div>';

            jQuery(actionsHtml).appendTo(cart_summary);

            
          } else {
            jQuery('<div class="empty text-center">Tu carrito está vacío <a href="/collections/all" class="btn">Seguir comprando</a></div>').appendTo(cart_summary);
          }
        }
      });
    }
  }

  // Update cart count.
  if ((typeof cart_count_id) === 'string') {
    if (cart.item_count == 0) {
      jQuery('#' + cart_count_id).html('Translation missing: es.products.ajax_cart.empty');
    }
    else if (cart.item_count == 1) {
      jQuery('#' + cart_count_id).html('Translation missing: es.products.ajax_cart.have1');
    }
    else {
      jQuery('#' + cart_count_id).html(cart.item_count + 'Tienes más productos en tu carrito');
    }
  }

  /* Update cart info */
  updateCartDesc(cart);
};

function updateCartDesc(data){
  var $cartLinkText = $('.navUser-item--cart span.cart-quantity');
  switch(data.item_count){
    case 0: $cartLinkText.html('0'); break;
    case 1: $cartLinkText.html('1'); break;
    default:$cartLinkText.html(data.item_count); break;
  }
  $('.ajax-cart-subtotal').html("<span class='money'>"+Shopify.formatMoney(data.total_price, cart_money_format)+"</span>");
  
  $('.price_text').html("<span class='money'>"+Shopify.formatMoney(data.total_price, cart_money_format)+"</span>");
  
}

Shopify.onCartUpdate = function(cart) {
  Shopify.updateCartInfo(cart, '.cart-info .cart-content', 'shopping-cart');
};

$(window).on('load', function() {
  // Mostrar contenido del carrito en el mini-cart al cargar
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '.cart-info .cart-content');
  });
});

function countDown(count) {
  if (!$('#ajax-cart-modal').length) return;
  if (count > 0) {
    if(count > 1) $(".countDiv").html("This popup will auto close after <span>"+count+"</span> seconds");
    else $(".countDiv").html("This popup will auto close after <span>"+count+"</span> second");

    if( checkCountDown == 1 ){
      setTimeout (function() { countDown(0); }, 0);
    } else {
      setTimeout (function() { countDown(count-1); }, 1000);
    }
  }
  else {
    ajaxCartHide();
  }
}